import { useContext } from 'react';
import { DocumentContext } from '../context';

export const useDocument = () => useContext(DocumentContext);
